module.exports = __webpack_public_path__ + "static/media/codeblockBigLogo.b28bf68d.png";